import { Text, TextProps } from '@chakra-ui/react';
import React from 'react';

type Props = {
  isEllipsis?: boolean;
} & TextProps;

export const CmText: React.FC<Props> = ({
  children,
  isEllipsis = false,
  ...rest
}) => {
  const ellipsis = {
    overflow: isEllipsis ? 'hidden' : undefined,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  } as const;

  if (isEllipsis) {
    // @ts-ignore TS2590
    return <Text {...{ ...ellipsis, ...rest }}>{children}</Text>;
  } else {
    return <Text {...rest}>{children}</Text>;
  }
};
